export const environment = {
  baseClaimSubmissionWebUrl: '#{BaseClaimSubmissionWebUrl}#',
  baseClaimSubmissionUrl: '#{BaseClaimSubmissionUrl}#',
  defaultRequestTimeout: '#{DefaultRequestTimeout}#',
  buildNumber: '#{Build.BuildNumber}#',
  tenantName: "#{TenantName}#",
  clientId: "#{ClientId}#",
  enableEstimateUi: '#{EnableEstimateUi}#',
  enableEstimateDragAndDrop: '#{EnableEstimateDragAndDrop}#',
  reCaptchaSiteKey: '#{reCaptchaSiteKey}#',
  maxFileSizeMB: '#{MaxFileSizeMB}#',
  maxFiles: '#{MaxFiles}#'
};